import React, { useRef, useState, useEffect } from 'react';
import './superxIndex.css'
import C2wSuperxLanding from '../../components/C2wSuperx/landing/landing';
import C2wSuperxJourney from '../../components/C2wSuperx/journey/journey';
import C2wSuperxBenefits from '../../components/C2wSuperx/benefits/benefits';
import C2wSuperxDomains from '../../components/C2wSuperx/domains/domains';
import C2wSuperxProjects from '../../components/C2wSuperx/projects/projects';
import C2wSuperxTestimonials from '../../components/C2wSuperx/testimonials/testimonials';
import C2wSuperxBatches from '../../components/C2wSuperx/batches/batches';
import Footer from './../c2wHomePage/Footer';
import C2wSuperxContentbar from '../../components/C2wSuperx/navbar/navbar';
import { Helmet } from 'react-helmet';
import { Element, Helpers } from 'react-scroll';


function C2wSuperxHome() {

  window.addEventListener("scroll", () => {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
  });

  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
      useEffect(() => {
        const handleResize = () => {
          setWindowWidth(window.innerWidth);
        };
    
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
      }, []);


  const components = [
    <C2wSuperxLanding />,
    <C2wSuperxJourney />,
    <C2wSuperxBenefits />,
    // <C2wSuperxDomains />,
    // <C2wSuperxProjects />,
    <C2wSuperxTestimonials />,
    // <C2wSuperxBatches />
  ];

  const sectionElements = ['Highlights', 'Journey', 'Benefits', 'Domains', 'Projects', 'Testimonials', 'Batches']

  const sectionRefs = useRef([]);
  const [activeIndex, setActiveIndex] = useState(null);
  

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            const index = Number(entry.target.getAttribute("data-index"));
            setActiveIndex(index);
            console.log(index)
          }
        });
      },
      {
        root: null,
        rootMargin: "0px",
        threshold: 0.5, // Adjust based on how much of the component should be visible
      }
    );

    sectionRefs.current.forEach((ref) => {
      if (ref) observer.observe(ref);
    });

    return () => {
      sectionRefs.current.forEach((ref) => {
        if (ref) observer.unobserve(ref);
      });
    };
  }, []);

  return (
    <div className='C2wSuperxHome_ctn' id='C2wSuperxHomeId'>
      <Helmet>
        {/* 
                    Purpose: Defines the page title displayed in search results and browser tabs. 
                             It’s one of the most important SEO elements. 
                    */}
        <title>{`Project Implementation Event`}</title>

        {/* 
                    Purpose: Provides a brief summary of the page content in search results. 
                             While not a direct ranking factor, it influences CTR. 
                    */}
        <meta name="description" content="" />

        {/* Purpose: Controls indexing and link-following behavior. */}
        <meta name="robots" content="index, follow" />

      </Helmet>
      {/* {(activeIndex !== 0 && windowWidth > 768) &&  <C2wSuperxContentbar sectionElements={sectionElements} activeIndex={activeIndex} />} */}
      {components.map((Component, index) => (
        <Element name={sectionElements[index]}>
          <div
            key={index}
            ref={(el) => (sectionRefs.current[index] = el)}
            data-index={index}
          >
            {Component}
          </div>
        </Element>
      ))}
      <div className="ADfooter__container">
        <Footer /></div>
    </div>
  )
}

export default C2wSuperxHome
